const scheduledServicesCalendarHeader = {
  title: "Calendario Servicios Programados",
  filters: "Filtros",
  clear: "Limpiar",
};

export default scheduledServicesCalendarHeader;
